import { revalidateLogic } from "@tanstack/react-form";
import { deliveryOptionFormOpts } from "@/components/Delivery/delivery-options/option.form.opts";
import { useAppForm } from "@/components/Forms";
import type { DeliveryOptionFormValues } from "@/schemas/DeliveryForm/delivery-option.schema";

type UseDeliveryOptionFormOptions = {
  defaultValues: DeliveryOptionFormValues;
  onSubmit: (value: DeliveryOptionFormValues) => Promise<void>;
};

export function useDeliveryOptionForm({ defaultValues, onSubmit }: UseDeliveryOptionFormOptions) {
  // Spread shared formOptions so this instance matches withForm({ ...deliveryOptionFormOpts })
  // https://tanstack.com/form/latest/docs/framework/react/guides/form-composition
  return useAppForm({
    ...deliveryOptionFormOpts,
    defaultValues,
    validationLogic: revalidateLogic(),
    onSubmit: async ({ value }) => {
      await onSubmit(value);
    },
  });
}
